(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps-campaign"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value

      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auto-cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-auto-cards-scroller-script')
    if (!window.autoCardsScroller && $url) {
      window.autoCardsScroller = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.autoCardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-scroll-change"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-banner-scroll-change-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-with-countdown"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-banner-with-countdown-script')
    if (!window.bannerWithCountdown && $url) {
      window.bannerWithCountdown = $url.value

      var $script = document.createElement('script')
      $script.src = window.bannerWithCountdown
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-image-group"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-before-after-image-group-script')
    if (!window.beforeAfterImageGroup && $url) {
      window.beforeAfterImageGroup = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.beforeAfterImageGroup
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bionic-flexFit-backrest"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-bionic-flexFit-backrest-script')
    if (!window.imageParameterToggle && $url) {
      window.imageParameterToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageParameterToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-product"] && !Shopify.designMode) return;
  try {
    

  (function() {
    var $url = document.querySelector('.as-bulk-product-script')
    if (!window.bulkProduct && $url && $url.dataset.designMode !== 'yes') {
      window.bulkProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.bulkProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-screen-change"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var $url = document.querySelector('.as-card-screen-change-script')
      if (!window.cardScreenChange && $url) {
        window.cardScreenChange = $url.value
    
        var $script = document.createElement('script')
        $script.src = window.cardScreenChange
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-scroller-v2"] && !Shopify.designMode) return;
  try {
    
  // (function() {
  //   var $url = document.querySelector('.as-cards-scroller-script')
  //   if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
  //     window.cardsScroller = $url.value

  //     var $script = document.createElement('script')
  //     $script.src = window.cardsScroller
  //     $script.defer = "defer"
  //     document.body.appendChild($script)
  //   }
  // })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-video-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-video-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-bg-zoomout"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-common-bg-zoomout-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creativity-spot-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-spot-cards-script')
    if (!window.spotCards && $url) {
      window.spotCards = true

      var $script = document.createElement('script')
      $script.src = $url.value
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-sliders-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-custom-image-sliders-v2-script')
    if (! window.customImageSlidersV2 && $url && $url.dataset.designMode !== 'yes') {
       window.customImageSlidersV2 = $url.value
      var $script = document.createElement('script')
      $script.src =  window.customImageSlidersV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-custom-image-sliders-script')
    if (!window.customImageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.customImageSliders = $url.value
      var $script = document.createElement('script')
      $script.src = window.customImageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-support-system-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-dynamic-support-system-v2-script')
    if (!window.stackedImageCards && $url) {
      window.dynamicSupportSystemV2 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.dynamicSupportSystemV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exhibition-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-exhibition-banner-script')
  if (!window.exhibitionBanner && $url) {
    window.exhibitionBanner = $url.value

    var $script = document.createElement('script')
    $script.src = window.exhibitionBanner
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exhibition-column"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-exhibition-column-script')
  if (!window.exhibitionColumn && $url) {
    window.exhibitionColumn = $url.value

    var $script = document.createElement('script')
    $script.src = window.exhibitionColumn
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exhibition-timeline"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-exhibition-timeline-script')
  if (!window.exhibitionTimeline && $url) {
    window.exhibitionTimeline = $url.value

    var $script = document.createElement('script')
    $script.src = window.exhibitionTimeline
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-detail"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $input = document.querySelector('.as-fabric-detail-script')
    if ($input && !window.FabricDetailInit && $input.dataset.designMode !== 'yes') {
      window.FabricDetailInit = true
      var $script = document.createElement('script')
      $script.src = $input.value
      $script.defer = 'defer'
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-grid-swiper"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-feature-grid-swiper-script')
    if (!window.featureGridSwiper && $url) {
      window.featureGridSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window.featureGridSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-background"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-background-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-zoom-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-screen-zoom-text-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hear-from-us"]) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-hear-from-us-script')
  if (!window.mediaCardsWithYTB && $url) {
    window.mediaCardsWithYTB = $url.value
    var $script = document.createElement('script')
    $script.src = window.mediaCardsWithYTB
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-spec-stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-image-stairs-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-image-card-with-tab-script');
    if (!window.imageCardWithTabScript && $url) {
      window.imageCardWithTabScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.imageCardWithTabScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"]) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-gallery-script')
  if (!window.imageGallery && $url) {
    window.imageGallery = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageGallery
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-parameter-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-parameter-toggle-script')
    if (!window.imageParameterToggle && $url) {
      window.imageParameterToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageParameterToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-v2-script')
    if (!window.imageSlidersV2 && $url && $url.dataset.designMode !== 'yes') {
      window.imageSlidersV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSlidersV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-collapese-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-collapse-list-script')
    if (!window.imageTextCollapseList && $url) {
      window.imageTextCollapseList = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextCollapseList
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-collapse-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-collapse-list-script')
    if (!window.imageTextCollapseList && $url) {
      window.imageTextCollapseList = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextCollapseList
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-collapse"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-collapse-script')
    if (!window.imageTextCollapse && $url) {
      window.imageTextCollapse = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextCollapse
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-toggle-script')
    if (!window.imageTextToggle && $url) {
      window.imageTextToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-toggle-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-toggle-v2-script')
    if (!window.imageToggleV2 && $url) {
      window.imageToggleV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageToggleV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-toggle-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-toggle-v3-script')
    if (!window.imageToggleV2 && $url) {
      window.imageToggleV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageToggleV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-toggle-script')
    if (!window.imageToggle && $url) {
      window.imageToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-with-text-toggle-script')
    if (!window.imageWithTextToggle && $url) {
      window.imageWithTextToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageWithTextToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $abTestProductV3 = document.querySelector('.as-ab-test-product-v3');
    if ($abTestProductV3 != null) {
      function getCookie(c_name) {
      if (document.cookie.length > 0) {
          c_start = document.cookie.indexOf(c_name + "=");
          if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
              c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
          }
        }
        return "";
      }
      var abTestVersion = $abTestProductV3?.dataset.abTestVersion ?? ''
      var abtno = getCookie('abtno')
      if (abtno === undefined) return
      if (abTestVersion === '') return
      var willShow = Number(abtno) < 500 ? 'a' : 'b'
      
      if (willShow === abTestVersion) {
        $abTestProductV3?.classList.remove('h-hidden')
  
        var $url = document.querySelector('.as-main-product-v3-script')
        if (!window.productV3 && $url && $url.dataset.designMode !== 'yes') {
          window.productV3 = $url.value
          var $script = document.createElement('script')
          $script.src = window.productV3
          $script.defer = "defer"
          document.body.appendChild($script)
        }
      } else {
        $abTestProductV3?.classList.add('h-hidden')
        $abTestProductV3?.remove()
      }
    } else {
      var $url = document.querySelector('.as-main-product-v3-script')
      if (!window.productV3 && $url && $url.dataset.designMode !== 'yes') {
        window.productV3 = $url.value
        var $script = document.createElement('script')
        $script.src = window.productV3
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v4"]) return;
  try {
    

  (function() {
    var $abTestProductV4 = document.querySelector('.as-ab-test-product-v4');
    if ($abTestProductV4 != null) {
      function getCookie(c_name) {
      if (document.cookie.length > 0) {
          c_start = document.cookie.indexOf(c_name + "=");
          if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
              c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
          }
        }
        return "";
      }
      var abTestVersion = $abTestProductV4?.dataset.abTestVersion ?? ''
      var abtno = getCookie('abtno')
      if (abTestVersion === '') return
      if (abtno === undefined) return
      var willShow = Number(abtno) < 500 ? 'a' : 'b'
      
      if (willShow === abTestVersion) {
        $abTestProductV4?.classList.remove('h-hidden')
  
        var $url = document.querySelector('.as-main-product-v4-script')
        if (!window.productV4 && $url && $url.dataset.designMode !== 'yes') {
          window.productV4 = $url.value
          var $script = document.createElement('script')
          $script.src = window.productV4
          $script.defer = "defer"
          document.body.appendChild($script)
        }
      } else {
        $abTestProductV4?.classList.add('h-hidden')
        $abTestProductV4?.remove()
      }
    } else {
      var $url = document.querySelector('.as-main-product-v4-script')
      if (!window.productV4 && $url && $url.dataset.designMode !== 'yes') {
        window.productV4 = $url.value
        var $script = document.createElement('script')
        $script.src = window.productV4
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-card-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-media-card-with-tab-script');
    if (!window.mediaCardWithTabScript && $url) {
      window.mediaCardWithTabScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.mediaCardWithTabScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards-change"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-cards-change-script')
    if (!window.stackedImageCards && $url) {
      window.mediaCardsChange = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.mediaCardsChange
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards-with-ytb-max-pdp"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-cards-with-ytb-max-pdp-script')
  if (!window.MediaCardsWithYTBMaxPdp && $url) {
    window.MediaCardsWithYTBMaxPdp = $url.value
    var $script = document.createElement('script')
    $script.src = window.MediaCardsWithYTBMaxPdp
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards-with-ytb"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-cards-with-ytb-script')
  if (!window.mediaCardsWithYTB && $url) {
    window.mediaCardsWithYTB = $url.value
    var $script = document.createElement('script')
    $script.src = window.mediaCardsWithYTB
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-cards-script')
  if (!window.mediaCards && $url) {
    window.mediaCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.mediaCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-v2-script')
    if (!window.mediaReviewsV2 && $url) {
      window.mediaReviewsV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaReviewsV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $ribbonUrl = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $ribbonUrl) {
      window.creativeGsap = $ribbonUrl.value

      var $ribbonScript = document.createElement('script')
      $ribbonScript.src = window.creativeGsap
      $ribbonScript.defer = "defer"
      document.body.appendChild($ribbonScript)
    }

    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-tab-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-tab-v2-script')
    if (!window.mediaTabV2 && $url) {
      window.mediaTabV2 = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaTabV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-tab-script')
    if (!window.mediaTab && $url) {
      window.mediaTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-text-toggle-script')
    if (!window.mediaTextToggle && $url) {
      window.mediaTextToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaTextToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-toggle-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-toggle-v2-script')
    if (!window.mediaToggle && $url) {
      window.mediaToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-toggle"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-toggle-script')
    if (!window.mediaToggle && $url) {
      window.mediaToggle = $url.value

      var $script = document.createElement('script')
      $script.src = window.mediaToggle
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone-horizontal"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-milestone-horizontal-script')
    if (!window.milestoneHorizontal && $url && $url.dataset.designMode !== 'yes') {
      window.milestoneHorizontal = $url.value

      var $script = document.createElement('script')
      $script.src = window.milestoneHorizontal
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-multi-cards-script')
    if (!window.multiCards && $url) {
      window.multiCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.multiCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-image-card-campaign"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-image-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-video-swiper-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-video-swiper-script')
  if (!window.mutiVideoSwiper && $url) {
    window.mutiVideoSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.mutiVideoSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }

  var $url2 = document.querySelector('.as-ribbon-image-script')
  if (!window.creativeGsap && $url2) {
    window.creativeGsap = $url2.value

    var $script = document.createElement('script')
    $script.src = window.creativeGsap
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-video-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-video-swiper-script')
  if (!window.mutiVideoSwiper && $url) {
    window.mutiVideoSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.mutiVideoSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-video-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-multi-video-with-tab-script');
    if (!window.multiVideoWithTabScript && $url) {
      window.multiVideoWithTabScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.multiVideoWithTabScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-youtube-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-youtube-swiper-script')
  if (!window.multiYoutubeSwiper && $url) {
    window.multiYoutubeSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.multiYoutubeSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-item-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-title-with-tab-script')
    if (!window.titleWithTab && $url) {
      window.titleWithTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.titleWithTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-scrolling-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-parallax-scrolling-cards-script')
    if (!window.ParallaxScrollingCards && $url) {
      window.ParallaxScrollingCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.ParallaxScrollingCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-with-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let $url = document.querySelector('.as-product-card-with-tab-script');
    if (!window.productCardWithTabScript && $url) {
      window.productCardWithTabScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.productCardWithTabScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-compare-v2-script')
    if (!window.productCompareV2 && $url) {
      window.productCompareV2 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.productCompareV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-compare-v3-script')
    if (!window.productCompareV3 && $url) {
      window.productCompareV3 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.productCompareV3
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-v4"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-compare-v4-script')
    if (!window.productCompareV4 && $url) {
      window.productCompareV4 = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.productCompareV4
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-series"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-series-script')
    if (!window.ProductSeriesSwiper && $url && $url.dataset.designMode !== 'yes') {
      window.ProductSeriesSwiper = $url.value
      var $script = document.createElement('script')
      $script.src = window.ProductSeriesSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-seriess-slide"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-product-seriess-slide-script')
  if (!window.productSeriessSlide && $url) {
    window.productSeriessSlide = $url.value

    var $script = document.createElement('script')
    $script.src = window.productSeriessSlide
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewer-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-viewer-v2-script')
    if (!window.productViewerV2 && $url) {
      window.productViewerV2 = $url.value

      var $script = document.createElement('script') 
      $script.src = window.productViewerV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-viewer-script')
    if (!window.productViewer && $url) {
      window.productViewer = $url.value

      var $script = document.createElement('script') 
      $script.src = window.productViewer
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-review-sliders-script')
    if (!window.ReviewSliders && $url && $url.dataset.designMode !== 'yes') {
      window.ReviewSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.ReviewSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenario-tab-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scenario-tab-cards-script')
    if (!window.scenarioTabCards && $url && $url.dataset.designMode !== 'yes') {
      window.scenarioTabCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.scenarioTabCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-unlock-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scroll-unlock-cards-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-scene"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scrolling-scene-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video-expansion"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-social-video-expansion-script')
  if (!window.socialVideoExpansion && $url) {
    window.socialVideoExpansion = $url.value

    var $script = document.createElement('script')
    $script.src = window.socialVideoExpansion
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video-swiper-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-social-video-swiper-v2-script')
  if (!window.socialVideoSwiper && $url) {
    window.socialVideoSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.socialVideoSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video-swiper"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-social-video-swiper-script')
  if (!window.socialVideoSwiper && $url) {
    window.socialVideoSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.socialVideoSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spare-parts-collection-product-grid"]) return;
  try {
    
  (function () {
    const $url = document.querySelector('.as-spare-parts-collection-product-grid-script');
    if (!window.sparePartsCollectionProductGridScript && $url && $url.dataset.designMode !== 'yes') {
      window.sparePartsCollectionProductGridScript = $url.value;
      let $script = document.createElement('script');
      $script.src = window.sparePartsCollectionProductGridScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-the-wheel"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-ribbon-image-script')
  if (!window.creativeGsap && $url) {
    window.creativeGsap = $url.value

    var $script = document.createElement('script')
    $script.src = window.creativeGsap
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack-multi-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-stack-multi-cards-script')
  if (!window.stackMultiCards && $url) {
    window.stackMultiCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.stackMultiCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-stacked-image-cards-script')
  if (!window.stackedImageCards && $url) {
    window.stackedImageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.stackedImageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-ribbon-image-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value

      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stacked-multi-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stacked-multi-cards-script')
    if (!window.stackedMultiCards && $url) {
      window.stackedMultiCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.stackedMultiCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tagline-with-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-tagline-with-text-script')
    if (!window._taglineWithText && $url && $url.dataset.designMode !== 'yes') {
      window._taglineWithText = $url.value
      var $script = document.createElement('script')
      $script.src = window._taglineWithText
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-variant-tab-script')
    if (!window.variantTab && $url) {
      window.variantTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.variantTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-swiper-arrow-inner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-multi-video-swiper-arrow-inner-script')
  if (!window.mutiVideoSwiper && $url) {
    window.mutiVideoSwiper = $url.value

    var $script = document.createElement('script')
    $script.src = window.mutiVideoSwiper
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-video-with-image-cards-script')
  if (!window.videoWithImageCards && $url) {
    window.videoWithImageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.videoWithImageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();
})();
